module.exports = __webpack_public_path__ + "img/egyn-white.d898fed4.svg";